import { createConfig } from "wagmi";
import { createClient, http } from "viem";
import dappConfig from "./dapp.config";
import { mainnet, polygon, arbitrum, optimism, base, fantom, bsc, avalanche, linea, blast } from "wagmi/chains";

export const config = createConfig({
  chains: [mainnet, polygon, arbitrum, optimism, base, fantom, bsc, avalanche, linea, blast],
  multiInjectedProviderDiscovery: false,
  client({ chain }) {
    return createClient({ chain, transport: http(dappConfig.privateRPCs[chain.id]) });
  },
});
